/**
 * Award decision error helpers. Lives at feature level (not inside a component
 * folder) so both the drawers and the mutation hooks can import it without a
 * layering inversion.
 */

/** Backend error code returned when a decision was already finalised. */
export const AWARD_DECISION_FINAL_CODE = "AWARD_DECISION_FINAL";

/**
 * Extracts an application error code from an Axios-style error. The legacy
 * finality guard returns a top-level `code`, while the award endpoints return
 * `error_code`; check both so 409 `AWARD_DECISION_FINAL` is caught either way.
 */
export const getAwardErrorCode = (error: unknown): string | undefined => {
	if (!error || typeof error !== "object") {
		return undefined;
	}
	const response = (error as { response?: { data?: unknown } }).response;
	const data = response?.data;
	if (!data || typeof data !== "object") {
		return undefined;
	}
	const record = data as Record<string, unknown>;
	const code = record.error_code ?? record.code;
	return typeof code === "string" ? code : undefined;
};

/** True when the error represents an already-final award decision (409). */
export const isAwardDecisionFinal = (error: unknown): boolean =>
	getAwardErrorCode(error) === AWARD_DECISION_FINAL_CODE;
